import { normalizeGitDiffPath } from '../parse/normalize-git-diff-path.js';
import type { WorkingTreeChangeFileRow } from '../types.js';
import { pickPreferredChangedFileRow } from './pick-preferred-changed-file-row.js';

/** Prefer rename-aware rows when the same destination path appears more than once. */
export function dedupeChangedFileRows(rows: WorkingTreeChangeFileRow[]): WorkingTreeChangeFileRow[] {
  const byPath = new Map<string, WorkingTreeChangeFileRow>();
  for (const row of rows) {
    const key = normalizeGitDiffPath(row.workspaceRelPath);
    const normalizedRow = key === row.workspaceRelPath ? row : { ...row, workspaceRelPath: key };
    const existing = byPath.get(key);
    if (!existing) {
      byPath.set(key, normalizedRow);
      continue;
    }
    const preferRow = pickPreferredChangedFileRow(existing, normalizedRow);
    byPath.set(key, { ...preferRow, workspaceRelPath: key });
  }
  return [...byPath.values()];
}
